export default __webpack_public_path__ + "static/media/white-shape-bg.dd28bd4b.png";